import { render, staticRenderFns } from "./TableFormatWrap.vue?vue&type=template&id=8acee7de&"
import script from "./TableFormatWrap.vue?vue&type=script&lang=js&"
export * from "./TableFormatWrap.vue?vue&type=script&lang=js&"
import style0 from "./TableFormatWrap.vue?vue&type=style&index=0&id=8acee7de&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports